export default __webpack_public_path__ + "static/media/levels-active-icon.bd152be5.svg";